<template>
  <div>
    <main class="l-content">
      <MenuCarousel/>
    </main>
  </div>
</template>

<script>
  import MenuCarousel from '../components/MenuCarousel'
  export default {
    name: 'MenuList',
    components: {MenuCarousel}
  }
</script>

<style>

</style>
